document.addEventListener('DOMContentLoaded', () => {
  const progressTextElements = document.querySelectorAll('#progress-text p');
  const cartCardLists = document.querySelectorAll('.cart-card-list');
  let celebrationTriggered = false;

  // ─── Set Default Selected Variant on Page Load ─────────────────────────────

  function setDefaultSelectedVariant() {
    document.querySelectorAll('.product_content_info').forEach((infoContainer) => {
      const swatches = infoContainer.querySelectorAll('.block-swatch');
      if (swatches.length === 0) return;
      
      const hasSelected = Array.from(swatches).some(swatch => swatch.classList.contains('selected-variant'));
      
      if (!hasSelected) {
        const firstSwatch = swatches[0];
        firstSwatch.classList.add('selected-variant');
        
        // Apply inline style for border
        // firstSwatch.style.border = '1px solid #000';
        // // firstSwatch.style.outline = '2px solid #000';
        // firstSwatch.style.outlineOffset = '1px';
        
        const buttons = infoContainer.querySelectorAll('.bb-add-to-cart');
        buttons.forEach(button => {
          updateButtonFromSwatch(firstSwatch, button);
        });
        
        const priceElement = infoContainer.querySelector('sale-price');
        if (priceElement && firstSwatch.dataset.variantPrice) {
          const clean = firstSwatch.dataset.variantPrice.toString().replace('$', '').replace(' AUD', '');
          priceElement.innerHTML = `$${parseFloat(clean).toFixed(2)}`;
        }
        
        // Update product image for default variant
        const card = infoContainer.closest('product-card');
        const productImg = card?.querySelector('.product-card__image--primary');
        const productScript = infoContainer.querySelector('script[data-prodcut-variant]');
        const selectedVariantId = firstSwatch.dataset.variantId;
        
        if (productImg && selectedVariantId && productScript) {
          try {
            const handle = JSON.parse(productScript.textContent);
            fetch(`/products/${handle}.js`)
              .then(res => res.json())
              .then(productData => {
                const variant = productData.variants.find(v => String(v.id) === String(selectedVariantId));
                if (variant) {
                  let imageSrc = variant.featured_image?.src || variant.image?.src || '';
                  if (imageSrc && imageSrc.startsWith('//')) imageSrc = 'https:' + imageSrc;
                  if (imageSrc) {
                    productImg.src = imageSrc;
                    productImg.srcset = '';
                  }
                }
              })
              .catch(err => console.error('Fetch error:', err));
          } catch(e) {
            console.error('Parse error:', e);
          }
        }
      }
    });
  }

  function updateAllCartLists() {
    cartCardLists.forEach(cartCardList => {
      if (cartCardList) updateCartList(cartCardList, null, null);
    });
  }

  // ─── Variant Info ───────────────────────────────────────────────────────────

  function getVariantInfoFromSwatch(swatch) {
    const variantId     = swatch.dataset.variantId;
    const variantPrice  = swatch.dataset.variantPrice;
    const variantsPrice = swatch.dataset.variantsPrice;
    const variantName   = swatch.dataset.variantTitle || swatch.textContent?.trim() || '';
    const isTaupeTan    = variantName.toLowerCase().includes('taupe') ||
                          variantName.toLowerCase().includes('tan')   ||
                          variantName.toLowerCase().includes('cognac') ||
                          (parseFloat(variantPrice) > 100);
    return { variantId, variantPrice, variantsPrice, variantName, isTaupeTan };
  }

  function updateButtonFromSwatch(swatch, button) {
    if (!button) return;
    const info = getVariantInfoFromSwatch(swatch);
    button.dataset.variantId     = info.variantId;
    button.dataset.variantPrice  = info.variantPrice;
    button.dataset.variantsPrice = info.variantsPrice;
    button.dataset.variantName   = info.variantName;
    button.dataset.isTaupeTan    = info.isTaupeTan;
    const productType = swatch.dataset.productType || button.dataset.productType;
    if (productType) button.dataset.productType = productType;
  }

  // ─── Init buttons on load ───────────────────────────────────────────────────

  document.querySelectorAll('product-card').forEach(card => {
    ['desktop_info', 'mobile_info'].forEach(cls => {
      const info   = card.querySelector(`.product-card__info.${cls}`);
      if (!info) return;
      const button = info.querySelector('.bb-add-to-cart');
      const swatch = info.querySelector('.block-swatch');
      if (swatch && button) updateButtonFromSwatch(swatch, button);
    });
  });

  // ─── Helpers ────────────────────────────────────────────────────────────────

  function getProductTitle(button) {
    const row = button.closest('.product-card__info');
    return row?.querySelector('.product-title')?.textContent?.trim() || '';
  }

  function getAccessoryType(title) {
    const t = title.toLowerCase();
    if (t.includes('wet bag'))                         return 'wet-bag';
    if (t.includes('h-case') || t.includes('h case')) return 'h-case';
    if (t.includes('passport'))                        return 'passport-wallet';
    return 'accessory';
  }

  // ─── Selected Products Info ─────────────────────────────────────────────────

  function getSelectedProductsInfo() {
    const selectedButtons = document.querySelectorAll('.bb-add-to-cart.selected-product');
    let hasConvert = false, hasCarryAll = false, hasConnect = false;
    let hasWetBag  = false, hasHCase    = false, hasPassport = false;
    let isTaupeTanConnect = false;

    selectedButtons.forEach(btn => {
      const type  = btn.dataset.productType || '';
      const title = getProductTitle(btn);

      if      (type === 'h-convert')       { hasConvert  = true; }
      else if (type === 'h-carry-all')     { hasCarryAll = true; }
      else if (type === 'h-connect')       { hasConnect  = true; isTaupeTanConnect = btn.dataset.isTaupeTan === 'true'; }
      else if (type === 'wet-bag')         { hasWetBag   = true; }
      else if (type === 'h-case')          { hasHCase    = true; }
      else if (type === 'passport-wallet') { hasPassport = true; }
      else if (type === 'accessory') {
        const at = getAccessoryType(title);
        if      (at === 'wet-bag')         hasWetBag   = true;
        else if (at === 'h-case')          hasHCase    = true;
        else if (at === 'passport-wallet') hasPassport = true;
      }
    });

    return {
      selectedButtons,
      totalCount: selectedButtons.length,
      hasConvert, hasCarryAll, hasConnect,
      hasWetBag, hasHCase, hasPassport,
      isTaupeTanConnect
    };
  }

  // ─── Single source of truth for discount ───────────────────────────────────

 // ─── Single source of truth for discount ───────────────────────────────────

function calcDiscount({ hasConvert, hasCarryAll, hasConnect, hasWetBag, hasHCase, hasPassport, isTaupeTanConnect, totalCount }) {
  const tt = isTaupeTanConnect;
// Case 1: H-Convert + H-Carry
if (hasConvert && hasCarryAll && !hasConnect && !hasWetBag && !hasHCase && !hasPassport && totalCount === 2) {
  return 39;
}

// Case 2: H-Convert + H-Carry + H-Connect
if (hasConvert && hasCarryAll && hasConnect && !hasWetBag && !hasHCase && !hasPassport && totalCount === 3) {
  return 158 ;
}

// Case 3: Convert + Carry + Connect + H-Case
if (hasConvert && hasCarryAll && hasConnect && hasHCase && !hasWetBag && !hasPassport && totalCount === 4) {
  return  182 ;
}

// Case 4: Convert + Carry + Connect + Passport
if (hasConvert && hasCarryAll && hasConnect && hasPassport && !hasWetBag && !hasHCase && totalCount === 4) {
  return 182 ;
}

// Case 5: Convert + Carry + Connect + Wet Bag
if (hasConvert && hasCarryAll && hasConnect && hasWetBag && !hasHCase && !hasPassport && totalCount === 4) {
  return 172 ;
}

// Case 6: Convert + Carry + Connect + H-Case + Wet Bag
if (hasConvert && hasCarryAll && hasConnect && hasWetBag && hasHCase && !hasPassport && totalCount === 5) {
  return 196 ;
}

// Case 7: Convert + Carry + Connect + Passport + Wet Bag
if (hasConvert && hasCarryAll && hasConnect && hasWetBag && hasPassport && !hasHCase && totalCount === 5) {
  return  196 ;
}

// Case 8: Convert + Carry + Connect + H-Case + Passport
if (hasConvert && hasCarryAll && hasConnect && hasHCase && hasPassport && !hasWetBag && totalCount === 5) {
  return  206 ;
}

// Case 9: Full Bundle
if (hasConvert && hasCarryAll && hasConnect && hasWetBag && hasHCase && hasPassport && totalCount === 6) {
  return  220;
}

// Case 10: Convert + Carry + Wet Bag
if (hasCarryAll && hasConvert && hasWetBag && !hasConnect && !hasHCase && !hasPassport && totalCount === 3) {
  return 53;
}

// Case 11: Convert + Carry + H-Case
if (hasCarryAll && hasConvert && hasHCase && !hasConnect && !hasWetBag && !hasPassport && totalCount === 3) {
  return 63;
}

// Case 12: Convert + Carry + Passport
if (hasCarryAll && hasConvert && hasPassport && !hasConnect && !hasWetBag && !hasHCase && totalCount === 3) {
  return 63;
}

// Case 13: Convert + Carry + H-Case + Passport
if (hasCarryAll && hasConvert && hasHCase && hasPassport && !hasConnect && !hasWetBag && totalCount === 4) {
  return 87;
}

// Case 14: Convert + Carry + H-Case + Wet Bag
if (hasCarryAll && hasConvert && hasHCase && hasWetBag && !hasConnect && !hasPassport && totalCount === 4) {
  return 77;
}

// Case 15: Convert + Carry + Passport + Wet Bag
if (hasCarryAll && hasConvert && hasPassport && hasWetBag && !hasConnect && !hasHCase && totalCount === 4) {
  return 77;
}

// Case 16: Convert + Carry + H-Case + Passport + Wet Bag
if (hasCarryAll && hasConvert && hasHCase && hasPassport && hasWetBag && !hasConnect && totalCount === 5) {
  return 101;
}

// Case 17: Single Bag + Connect
if ((hasConvert || hasCarryAll) && hasConnect && !(hasConvert && hasCarryAll) && !hasWetBag && !hasHCase && !hasPassport && totalCount === 2) {
  return 119 ;
}

// Case 18: Single Bag + Connect + H-Case
if ((hasConvert || hasCarryAll) && hasConnect && hasHCase && !hasWetBag && !hasPassport && !(hasConvert && hasCarryAll) && totalCount === 3) {
  return  143 ;
}

// Case 19: Single Bag + Connect + Passport
if ((hasConvert || hasCarryAll) && hasConnect && hasPassport && !hasWetBag && !hasHCase && !(hasConvert && hasCarryAll) && totalCount === 3) {
  return  143 ;
}

// Case 20: Single Bag + Connect + Wet Bag
if ((hasConvert || hasCarryAll) && hasConnect && hasWetBag && !hasPassport && !hasHCase && !(hasConvert && hasCarryAll) && totalCount === 3) {
  return  133 ;
}

// Case 21: Single Bag + Connect + H-Case + Passport
if ((hasConvert || hasCarryAll) && hasConnect && hasHCase && hasPassport && !hasWetBag && !(hasConvert && hasCarryAll) && totalCount === 4) {
  return  167 ;
}

// Case 22: Single Bag + Connect + H-Case + Wet Bag
if ((hasConvert || hasCarryAll) && hasConnect && hasWetBag && hasHCase && !hasPassport && !(hasConvert && hasCarryAll) && totalCount === 4) {
  return  157 ;
}

// Case 23: Single Bag + Connect + Passport + Wet Bag
if ((hasConvert || hasCarryAll) && hasConnect && hasWetBag && hasPassport && !hasHCase && !(hasConvert && hasCarryAll) && totalCount === 4) {
  return  157 ;
}

// Case 24: Single Bag + Connect + H-Case + Passport + Wet Bag
if (hasConvert  && hasConnect && hasWetBag && hasHCase && hasPassport  && totalCount === 5) {
  return  181  ;
}
if ( hasCarryAll && hasConnect && hasWetBag && hasHCase && hasPassport  && totalCount === 5) {
  return  181  ;
}
// Case 25: Single Bag + H-Case + Wet Bag
if ((hasConvert || hasCarryAll) && hasHCase && hasWetBag && !hasConnect && !hasPassport && !(hasConvert && hasCarryAll) && totalCount === 3) {
  return 38;
}

// Case 26: Single Bag + H-Case + Passport
if ((hasConvert || hasCarryAll) && hasHCase && hasPassport && !hasConnect && !hasWetBag && !(hasConvert && hasCarryAll) && totalCount === 3) {
  return 48;
}

// Case 27: Single Bag + Passport + Wet Bag
if ((hasConvert || hasCarryAll) && hasPassport && hasWetBag && !hasConnect && !hasHCase && !(hasConvert && hasCarryAll) && totalCount === 3) {
  return 38;
}

// Case 28: H-Connect + H-Case + Passport
if (hasConnect && hasHCase && hasPassport && !hasConvert && !hasCarryAll && !hasWetBag && totalCount === 3) {
  return 167  ;
}

// Case 29: H-Connect + H-Case + Wet Bag
if (hasConnect && hasHCase && hasWetBag && !hasConvert && !hasCarryAll && !hasPassport && totalCount === 3) {
  return  157 ;
}

// Case 30: H-Connect + Passport + Wet Bag
if (hasConnect && hasPassport && hasWetBag && !hasConvert && !hasCarryAll && !hasHCase && totalCount === 3) {
  return 157  ;
}
if ( hasConvert && hasWetBag && !hasCarryAll && !hasConnect && !hasHCase && !hasPassport && totalCount === 2 ) 
  { return 14; }
if ( hasConvert && hasPassport && !hasCarryAll && !hasConnect && !hasHCase && !hasWetBag && totalCount === 2 ) 
  { return 24; }
// H-Convert + H Case 
if ( hasConvert && hasHCase && !hasCarryAll && !hasConnect && !hasWetBag && !hasPassport && totalCount === 2 ) { return 24; }
// H-Carry + Wet Bag 
if ( hasCarryAll && hasWetBag && !hasConvert && !hasConnect && !hasHCase && !hasPassport && totalCount === 2 ) { return 14; }
if ( hasCarryAll && hasHCase && !hasConvert && !hasConnect && !hasWetBag && !hasPassport && totalCount === 2 ) { return 24; }
// H-Carry + Passport Wallet 
if ( hasCarryAll && hasPassport && !hasConvert && !hasConnect && !hasWetBag && !hasHCase && totalCount === 2 ) { return 24; }
// H-Connect + Wet Bag 
if ( hasConnect && hasWetBag && !hasConvert && !hasCarryAll && !hasHCase && !hasPassport && totalCount === 2 ) { return  133 ; }
// H-Connect + H Case
 if ( hasConnect && hasHCase && !hasConvert && !hasCarryAll && !hasWetBag && !hasPassport && totalCount === 2 ) { return  143 ; }
 if ( hasConnect && hasPassport && !hasConvert && !hasCarryAll && !hasWetBag && !hasHCase && totalCount === 2 ) { return  143 ; }
 if ( hasCarryAll  &&  hasHCase && hasWetBag && hasPassport && totalCount === 4) {
  return  62 ;
}
 if (hasConvert  &&  hasHCase && hasWetBag && hasPassport && totalCount === 4) {
  return  62 ;
}
if (hasConnect &&  hasHCase && hasWetBag && hasPassport && totalCount === 4) {
  return  181 ;
}
return 0;
}


  // ─── Celebration ────────────────────────────────────────────────────────────

  function triggerCelebration() {
    const cel = document.getElementById('bb-cel');
    if (cel) { cel.classList.add('bb-cel-wrap--show'); cel.setAttribute('aria-hidden', 'false'); }
    spawnConfetti();
  }

  function closeCelebration() {
    const cel = document.getElementById('bb-cel');
    if (cel) { cel.classList.remove('bb-cel-wrap--show'); cel.setAttribute('aria-hidden', 'true'); }
  }

  function spawnConfetti() {
    const wrap = document.getElementById('bb-confetti');
    if (!wrap) return;
    wrap.innerHTML = '';
    const colours = ['#1a1a1a','#c8b89a','#c9a87c','#5c3d2e','#b8860b','#2e7d32','#c9960c'];
    for (let i = 0; i < 70; i++) {
      const d     = document.createElement('div');
      d.className = 'bb-conf-dot';
      const size  = 6 + Math.random() * 7;
      d.style.cssText = [
        'left:'               + (Math.random() * 100) + 'vw',
        'top:0',
        'background:'         + colours[i % colours.length],
        'width:'              + size + 'px',
        'height:'             + size + 'px',
        'animation-duration:' + (1.3 + Math.random() * 2) + 's',
        'animation-delay:'    + (Math.random() * 0.5) + 's'
      ].join(';');
      wrap.appendChild(d);
    }
    setTimeout(() => { wrap.innerHTML = ''; }, 3500);
  }

  function checkAndTriggerCelebration() {
    const { hasConvert, hasCarryAll, hasConnect } = getSelectedProductsInfo();
    const shouldCelebrate = hasConvert && hasCarryAll && hasConnect;
    if (shouldCelebrate && !celebrationTriggered) {
      celebrationTriggered = true;
      triggerCelebration();
    }
    if (!shouldCelebrate) celebrationTriggered = false;
  }

  // ─── Global Remove Listener ─────────────────────────────────────────────────

  function initGlobalRemoveListener() {
    document.body.addEventListener('click', function(e) {
      const removeBtn = e.target.closest('.byob-summary__item-remove');
      if (!removeBtn) return;
      e.preventDefault();
      e.stopPropagation();

      const titleToRemove = removeBtn.getAttribute('data-product-title');
      if (!titleToRemove) return;

      let removed = false;
      document.querySelectorAll('.bb-add-to-cart').forEach(btn => {
        if (getProductTitle(btn) === titleToRemove && btn.classList.contains('selected-product')) {
          btn.classList.remove('selected-product');
          removed = true;
        }
      });

      if (removed) {
        setTimeout(() => {
          updateAllCartLists();
          updateBundleTotal();
          updateProgressText();
          updateProgressBar();
          updatePerProductPrices();
          checkAndTriggerCelebration();
        }, 50);
      }
    });
  }

  // ─── Slider ─────────────────────────────────────────────────────────────────

  function initSliderForCart(cartCardList, itemCount) {
    const container = cartCardList.closest('.cart-slider-container');
    if (!container) return;
    const prevBtn = container.querySelector('.slider-prev');
    const nextBtn = container.querySelector('.slider-next');

    if (itemCount > 3) {
      cartCardList.classList.add('has-scroll');
      container.classList.add('has-many-items');
      if (prevBtn && nextBtn) {
        const newPrev = prevBtn.cloneNode(true);
        const newNext = nextBtn.cloneNode(true);
        prevBtn.parentNode.replaceChild(newPrev, prevBtn);
        nextBtn.parentNode.replaceChild(newNext, nextBtn);
        newPrev.addEventListener('click', e => { e.preventDefault(); cartCardList.scrollBy({ left: -150, behavior: 'smooth' }); });
        newNext.addEventListener('click', e => { e.preventDefault(); cartCardList.scrollBy({ left:  150, behavior: 'smooth' }); });
      }
    } else {
      cartCardList.classList.remove('has-scroll');
      container.classList.remove('has-many-items');
    }
  }

  // ─── Cart List ──────────────────────────────────────────────────────────────

  function updateCartList(cartCardList, updatedCard, newImageSrc) {
    if (!cartCardList) return;
    const { selectedButtons: selectedProducts } = getSelectedProductsInfo();
    cartCardList.innerHTML = '';

    if (selectedProducts.length === 0) {
      for (let i = 0; i < 3; i++) {
        cartCardList.innerHTML += `
          <li class="cart-card__item">
            <div class="cart-card__item-image cart-card__item-image--placeholder">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M11.9531 3C12.4707 3.00014 12.8969 3.39341 12.9482 3.89746L12.9531 4V10.9531H19.9053L20.0078 10.958C20.5121 11.0092 20.9053 11.4353 20.9053 11.9531C20.9051 12.4708 20.512 12.8971 20.0078 12.9482L19.9053 12.9531H12.9531V19.9053C12.9531 20.4575 12.5053 20.9051 11.9531 20.9053C11.4008 20.9053 10.9531 20.4576 10.9531 19.9053V12.9531H4C3.44782 12.9531 3.00017 12.5053 3 11.9531C3 11.4008 3.44772 10.9531 4 10.9531H10.9531V4L10.958 3.89746C11.0094 3.39335 11.4355 3 11.9531 3Z" fill="currentColor"/>
              </svg>
            </div>
            <div class="cart-card__item-title"></div>
          </li>`;
      }
      cartCardList.classList.remove('has-scroll');
      return;
    }

    const processedCards = new Set();

    selectedProducts.forEach((button, index) => {
      const card = button.closest('product-card');
      if (!card || processedCards.has(card)) return;
      processedCards.add(card);

      const imgEl  = card.querySelector('.product-card__image--primary');
      const imgSrc = (updatedCard && card === updatedCard && newImageSrc)
                   ? newImageSrc
                   : (imgEl ? imgEl.src : '');

      const title = getProductTitle(button);

      cartCardList.innerHTML += `
        <li class="cart-card__item product_item" data-index="${index}">
          <div class="cart-card__item-image">
            <img src="${imgSrc}" alt="${title}" style="width:100%;height:100%;object-fit:cover;border-radius:8px;">
            <button type="button" class="byob-summary__item-remove" data-product-title="${title}">
              <svg width="9" height="9" viewBox="0 0 9 9" fill="none">
                <path d="M7.32031 0.332825C7.58516 0.0708395 8.01216 0.0730482 8.27441 0.337708C8.53644 0.60241 8.53484 1.02947 8.27051 1.29181L5.42871 4.10626L8.27051 6.92072C8.53484 7.18306 8.53645 7.61011 8.27441 7.87482C8.01216 8.13948 7.58516 8.14168 7.32031 7.8797L4.46973 5.05548L1.62012 7.8797C1.35533 8.14178 0.928323 8.13939 0.666016 7.87482C0.403862 7.60997 0.406148 7.18301 0.670898 6.92072L3.51074 4.10626L0.670898 1.29181C0.40614 1.02951 0.403859 0.602557 0.666016 0.337708C0.928325 0.0731223 1.35532 0.0707332 1.62012 0.332825L4.46973 3.15607L7.32031 0.332825Z" fill="currentColor"/>
              </svg>
            </button>
          </div>
          <div class="cart-card__item-title">${title}</div>
        </li>`;
    });

    initSliderForCart(cartCardList, processedCards.size);
  }

  function updateCartListsWithNewImage(updatedCard, newImageSrc) {
    cartCardLists.forEach(cartCardList => {
      if (cartCardList) updateCartList(cartCardList, updatedCard, newImageSrc);
    });
  }

  // ─── Progress Text ──────────────────────────────────────────────────────────

function updateProgressText() {
  const {
    hasConvert,
    hasCarryAll,
    hasConnect,
    totalCount,
    hasWetBag,
    hasHCase,
    hasPassport
  } = getSelectedProductsInfo();

  const hasHBag = hasConvert || hasCarryAll;
  const hasAccessory = hasWetBag || hasHCase || hasPassport;

  let message = '';

  if (!hasHBag && totalCount === 0) {
    message = 'Choose your H Bag to get started';
  }

  // 3 bags + accessory
  else if (
    hasConvert &&
    hasCarryAll &&
    hasConnect &&
    hasAccessory
  ) {
    message = '🎉H Vault unlocked! Maximum savings applied!';
  }

  // Only 3 bags
  else if (
    hasConvert &&
    hasCarryAll &&
    hasConnect &&
    !hasAccessory
  ) {
    message = '🎉 H Vault unlocked! Add accessories to save even more';
  }

  // // Convert + accessories without connect
  // else if (hasConvert && hasWetBag && hasHCase && totalCount === 3) {
  //   message = 'Add the H-Connect to unlock savings';
  // }

  // else if (hasHBag && !hasConnect) {
  //   message = 'Add the H-Connect to unlock savings';
  // }

  else if (totalCount >= 6) {
    message = 'Maximum items selected!';
  }

  else {
    message = 'Add the H-Connect to unlock savings';
  }

  progressTextElements.forEach(el => {
    if (el) el.textContent = message;
  });
}
  // ─── Progress Bar ───────────────────────────────────────────────────────────

  function updateProgressBar() {
    const { totalCount } = getSelectedProductsInfo();
    const progress = totalCount === 0 ? 0 : totalCount === 1 ? 23 : totalCount === 2 ? 40 : totalCount === 3 ? 80 : 100;

    document.querySelectorAll('#progess-fill').forEach(el => { if (el) el.style.width = progress + '%'; });

    document.querySelectorAll('.progress-tracking').forEach(tracking => {
      tracking.querySelectorAll('.byob-tiers__progress-marker').forEach((marker, index) => {
        const dot = marker.querySelector('.bb-rdot');
        if (dot) dot.classList.toggle('bb-rdot--active', totalCount > index);
      });
    });
  }

  // ─── Bundle Total ───────────────────────────────────────────────────────────

  function updateBundleTotal() {
    const info             = getSelectedProductsInfo();
    const selectedProducts = document.querySelectorAll('.bb-add-to-cart.selected-product');

    let originalTotal = 0;
    selectedProducts.forEach(btn => {
      const p = parseFloat(btn.dataset.variantsPrice);
      if (!isNaN(p)) originalTotal += p;
    });

    const discountAmount = calcDiscount({ ...info, totalCount: selectedProducts.length });
    const finalTotal     = Math.max(0, originalTotal - discountAmount);

    document.querySelectorAll('#bundle-compare-price').forEach(el => { if (el) el.innerHTML = `$${originalTotal.toFixed(2)}`; });
    document.querySelectorAll('#bundle-final-price').forEach(el =>   { if (el) el.innerHTML = `$${finalTotal.toFixed(2)}`;    });

    document.querySelectorAll('#bundle-discount-badge, #mobile-bundle-discount-badge').forEach(el => {
      if (!el) return;
      if (discountAmount > 0) {
        el.innerHTML     = `Save $${discountAmount.toFixed(2)}`;
        el.style.display = 'inline-block';
      } else {
        el.innerHTML     = '';
        el.style.display = 'none';
      }
    });

    const celSave = document.querySelector('.bb-cel-save');
    if (celSave && discountAmount > 0) celSave.innerHTML = `$${discountAmount.toFixed(2)}`;
  }

  // ─── Per-Product Prices ─────────────────────────────────────────────────────

  function updatePerProductPrices() {
    const selectedProducts = document.querySelectorAll('.bb-add-to-cart.selected-product');
    const info             = getSelectedProductsInfo();
    const totalDiscount    = calcDiscount({ ...info, totalCount: selectedProducts.length });

    let totalOriginal = 0;
    selectedProducts.forEach(btn => {
      const p = parseFloat(btn.dataset.variantsPrice || btn.dataset.variantPrice || 0);
      if (!isNaN(p)) totalOriginal += p;
    });

    document.querySelectorAll('price-list').forEach(pl => {
      pl.classList.remove('bb-has-discount');
      pl.querySelector('.bb-bundle-price')?.remove();
    });

    const processedCards = new Set();
    selectedProducts.forEach(button => {
      const card = button.closest('product-card');
      if (!card || processedCards.has(card)) return;
      processedCards.add(card);

      const originalPrice = parseFloat(button.dataset.variantsPrice || button.dataset.variantPrice || 0);

      card.querySelectorAll('price-list').forEach(priceList => {
        if (totalDiscount > 0 && totalOriginal > 0) {
          const discountedPrice = Math.max(0, originalPrice - (totalDiscount * (originalPrice / totalOriginal)));
          priceList.classList.add('bb-has-discount');
          const span     = document.createElement('span');
          span.className = 'bb-bundle-price';
          span.innerHTML = ` <strong class="bb-bundle-price-value">$${discountedPrice.toFixed(2)}</strong>`;
          priceList.appendChild(span);
        }
      });
    });
  }

  // ─── Add to Cart button clicks ──────────────────────────────────────────────

  document.querySelectorAll('.bb-add-to-cart').forEach(button => {
    button.addEventListener('click', function() {
      this.classList.toggle('selected-product');
      updateProgressBar();
      updateProgressText();
      updateBundleTotal();
      updateAllCartLists();
      updatePerProductPrices();
      checkAndTriggerCelebration();
    });
  });

  // ─── Build Cart Items ───────────────────────────────────────────────────────

  function buildCartItems() {
    const selectedProducts = document.querySelectorAll('.bb-add-to-cart.selected-product');
    if (selectedProducts.length > 6) { alert('You can only add 6 items'); return []; }

    const items = [];
    const processedCards = new Set();
    selectedProducts.forEach(button => {
      const card = button.closest('product-card');
      if (!card || processedCards.has(card)) return;
      processedCards.add(card);
      const variantId = button.dataset.variantId;
      if (variantId) {
        items.push({
          id: Number(variantId),
          quantity: 1,
          properties: { '_Bundle Builder': 'Yes', '_Bundle Product': getProductTitle(button) }
        });
      }
    });
    return items;
  }

  // ─── Add to Cart & Open Drawer ──────────────────────────────────────────────

  async function addToCartAndOpenDrawer(items, btnElement) {
    if (!items.length) { alert('Please select products'); return false; }
    try {
      if (btnElement) { btnElement.disabled = true; btnElement.textContent = 'Adding...'; }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('Cart error');

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      setTimeout(() => {
        const cartDrawer = document.querySelector('cart-drawer, #mini-cart, drawer-content, [data-cart-drawer]');
        if (cartDrawer) {
          if      (typeof cartDrawer.open === 'function') cartDrawer.open();
          else if (typeof cartDrawer.show === 'function') cartDrawer.show();
          else { cartDrawer.setAttribute('open', ''); cartDrawer.classList.add('is-open'); }
        }
      }, 800);

      if (btnElement) { btnElement.disabled = false; btnElement.textContent = 'Add bundle to cart'; }
      return true;

    } catch (error) {
      console.error('Cart Error:', error);
      alert('Something went wrong. Please try again.');
      if (btnElement) { btnElement.disabled = false; btnElement.textContent = 'Add bundle to cart'; }
      return false;
    }
  }

  async function bundleClickHandler(e) {
    e.preventDefault();
    await addToCartAndOpenDrawer(buildCartItems(), e.currentTarget);
  }

  document.querySelectorAll('.bb-add-to-cart-items').forEach(btn => {
    if (btn) { btn.removeEventListener('click', bundleClickHandler); btn.addEventListener('click', bundleClickHandler); }
  });

  // ─── Celebration Cart Button ────────────────────────────────────────────────

  async function handleCelAddClick(e) {
    e.preventDefault();
    const success = await addToCartAndOpenDrawer(buildCartItems(), e.currentTarget);
    if (success) closeCelebration();
  }

  function initCartButton() {
    const celBtn     = document.querySelector('#bb-cel-add');
    const celDismiss = document.querySelector('#bb-cel-dismiss');
    if (celBtn)     { celBtn.removeEventListener('click', handleCelAddClick); celBtn.addEventListener('click', handleCelAddClick); }
    if (celDismiss) { celDismiss.removeEventListener('click', closeCelebration); celDismiss.addEventListener('click', closeCelebration); }
  }

  // ─── Mobile Toggle ──────────────────────────────────────────────────────────

  function handleMobileToggle(e) {
    e.preventDefault();
    this.classList.toggle('mobile-summary__toggle-button--expanded');
    const cartItem = this.closest('.mobile-fotter')?.querySelector('.cart-item');
    if (cartItem) {
      cartItem.classList.toggle('cart-item--expanded');
      const isExpanded = cartItem.classList.contains('cart-item--expanded');
      this.setAttribute('aria-expanded', isExpanded);
      const span = this.querySelector('span');
      if (span) span.textContent = isExpanded ? 'Collapse' : 'Expand';
    }
  }

  function initMobileToggle() {
    document.querySelectorAll('.mobile-summary__toggle-button').forEach(btn => {
      btn.removeEventListener('click', handleMobileToggle);
      btn.addEventListener('click', handleMobileToggle);
    });
  }

  // ─── Swatch Click ───────────────────────────────────────────────────────────

  document.querySelectorAll('.block-swatch').forEach(function(swatch) {
    swatch.addEventListener('click', function() {
      const row = this.closest('.product-card__info');
      if (!row) return;

      row.querySelectorAll('.block-swatch').forEach(s => s.classList.remove('selected-variant'));
      this.classList.add('selected-variant');

      const card       = row.closest('product-card');
      const allButtons = card ? card.querySelectorAll('.bb-add-to-cart') : [];

      allButtons.forEach(btn => updateButtonFromSwatch(this, btn));

      const variantPrice = this.dataset.variantPrice;
      const priceElement = row.querySelector('sale-price');
      if (priceElement && variantPrice) {
        const clean = variantPrice.toString().replace('$', '').replace(' AUD', '');
        priceElement.innerHTML = `$${parseFloat(clean).toFixed(2)}`;
      }

      const anySelected       = Array.from(allButtons).some(btn => btn.classList.contains('selected-product'));
      const selectedVariantId = this.dataset.variantId;

      if (anySelected) {
        updateBundleTotal();
        updatePerProductPrices();
      }

      const productImg    = card?.querySelector('.product-card__image--primary');
      const productScript = row.querySelector('script[data-prodcut-variant]');

      if (productImg && selectedVariantId && productScript) {
        try {
          const handle = JSON.parse(productScript.textContent);

          fetch(`/products/${handle}.js`)
            .then(res => res.json())
            .then(productData => {
              const variant = productData.variants.find(v => String(v.id) === String(selectedVariantId));
              if (!variant) {
                if (anySelected) updateCartListsWithNewImage(card, productImg.src);
                return;
              }

              let imageSrc = variant.featured_image?.src || variant.image?.src || '';
              if (imageSrc && imageSrc.startsWith('//')) imageSrc = 'https:' + imageSrc;

              if (imageSrc) {
                productImg.src    = imageSrc;
                productImg.srcset = '';
                if (anySelected) updateCartListsWithNewImage(card, imageSrc);
              } else {
                if (anySelected) updateCartListsWithNewImage(card, productImg.src);
              }
            })
            .catch(err => {
              console.error('Fetch error:', err);
              if (anySelected) updateAllCartLists();
            });

        } catch(e) {
          console.error('Parse error:', e);
          if (anySelected) updateAllCartLists();
        }

      } else {
        if (anySelected) updateAllCartLists();
      }
    });
  });

  // ─── INITIALIZATION (ORDER MATTERS) ─────────────────────────────────────────

  setDefaultSelectedVariant();  // FIRST: Set default variant and border
  initGlobalRemoveListener();
  updateProgressText();
  updateProgressBar();
  updateAllCartLists();
  updateBundleTotal();
  updatePerProductPrices();
  initCartButton();
  initMobileToggle();
  checkAndTriggerCelebration();
const passportWallet = document.querySelector(
  'product-card[handle="passport-wallet"]'
);

window.addEventListener('scroll', () => {
  if (passportWallet.getBoundingClientRect().bottom <= window.innerHeight) {
    document.querySelector('.mobile-fotter')
      .classList.add('cart-active');
  } else {
    document.querySelector('.mobile-fotter')
      .classList.remove('cart-active');
  }
});
});